import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import { IBaseModel } from '../models/base.model';
import { firstValueFrom } from 'rxjs';
import { Comissao, GrupoTrabalho } from '../models/lotacao.model';

@Injectable({
    providedIn: 'root'
})
export class LotacaoService extends BaseService {
    controllerRoute = 'Lotacao';

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    public async getOrgaosGruposTrabalho(id: string): Promise<IBaseModel<GrupoTrabalho[]>> {
        return await firstValueFrom(this.httpClient.get<IBaseModel<GrupoTrabalho[]>>(`${this.apiBaseUrl}/${this.controllerRoute}/Orgaos/${id}/GruposTrabalho`));
    }

    public async getOrgaosComissoes(id: string): Promise<IBaseModel<Comissao[]>> {
        return await firstValueFrom(this.httpClient.get<IBaseModel<Comissao[]>>(`${this.apiBaseUrl}/${this.controllerRoute}/Orgaos/${id}/Comissoes`));
    }
}
